// @flow
import type {Element} from 'react'
import React from 'react'

import styles from './index.scss'

type Props = $ReadOnly<{
  value: string,
  autofocus: boolean,
  onChange: (e: SyntheticInputEvent<HTMLInputElement>) => void,
}>

/* eslint jsx-a11y/no-autofocus: 0 */
function QueryInput({value, onChange, autofocus}: Props): Element<"div"> {
  return (
    <div className={styles.container}>
      <input
        name="search"
        type="text"
        size="22"
        value={value}
        className={styles.sideBarSearchInput}
        onChange={onChange}
        placeholder={I18n.t('nav.search')}
        title={I18n.t('nav.search')}
        autoFocus={autofocus}
      />
    </div>
  )
}

export default QueryInput
